export const moduleErrors = {
	state() {
		return {
			globalErrorMessage: '',
			globalSuccessMessage: '',
		};
	},
	mutations: {
		setGlobalErrorMessage(state, data) {
			state.globalErrorMessage = data;
		},
		setGlobalSuccessMessage(state, data) {
			state.globalSuccessMessage = data;
		},
	},
	getters: {
		getGlobalErrorMessage: (state) => state.globalErrorMessage,
		getGlobalSuccessMessage: (state) => state.globalSuccessMessage,
	},
};
